module.exports = __webpack_public_path__ + "img/kuang_up_right_chang.f581ea1a.png";